//
//

import { mapActions, mapGetters, mapMutations } from "vuex";
import { uid, date } from "quasar";
import { required } from "vuelidate/lib/validators";
import FabricSearch from "@/components/q-fabric-search.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import { ENGINE_REST_PATH, GROUP_NAME_CHECK_REGEX } from "@/assets/js/appConfig";
import AddEditGroupMembers from "@/components/Admin/RolesAndUsers/AddEditGroupMembers/add-edit-group-members.vue";
import UserList from "@/components/tasks/userList/userList.vue";
import { convertAndFormatTimeToLocal, eventBus } from "@/assets/js/appFunc";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQToggle from "@/components/Generics/AQToggle/AQToggle.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQListBtn from "@/components/Generics/AQButtonsList/AQButtonsList.vue";
import AppAccessPermissions from "../../Application/AppPermissions/AppAccessPermissions.vue";
import RolesUsers from "../RolesUsers.vue";

const defaultAvatar = require("@/assets/images/user.svg");

export default {
    name: "AddEditRole",
    components: {
        RolesUsers,
        AddEditGroupMembers,
        UserList,
        AQButton,
        FabricSearch,
        AppAccessPermissions,
        AQModal,
        AQToggle,
        AQInput,
        AQBadge,
        AQDialog,
        AQTooltip,
        AQListBtn,
        AQCard
    },
    filters: {
        dateFormat(value) {
            return `${date.formatDate(value, "DD.MM.YYYY")} at ${convertAndFormatTimeToLocal(value, "HH:mm:ss")}`;
        }
    },
    props: {
        allGroupsTenantProcess: { type: Array, default: () => [] },
        inEditRow: { type: Object, default: () => {} },
        selectedRoleUsers: { type: Array, default: () => [] },
        selectedPermissions: { type: Array, default: () => [] },
        savedPermissionsToNewRole: { type: Array, default: () => [] },
        manageGroups: {
            type: Boolean,
            default: false
        },
        appSettings: {
            type: Boolean,
            default: false
        },
        fromAdmin: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            modalMembersClose: true,
            modalMembersSave: {
                label: this.$t("admin.usersAndRoles.addGroupMembers.addButtonTitle")
            },
            modalMembersCancel: true,
            show: true,
            showUsersDesc: true,
            opened: true,
            openedUserList: false,
            hasClose: true,
            hasCancel: false,
            userModal: false,
            addPermissionModal: false,
            userToBeDeleted: {},
            currentSelectedPermission: {},
            type: "PERMISSIONS_ROLES",
            currentRolePermissions: [],
            manualRolePermissions: "",
            currentAssignedUsers: [],
            error: false,
            oldRoleName: "",
            editedRoleDetails: {},
            currentCodeGroup: "",
            currentTypeGroup: "",
            dirty: false,
            showNewMembers: false, // show add/edit group members modal
            allGroupMembers: [], // containar all group members
            allGroupMembersIds: [], // containar all group members ids
            hasManager: null, // group manager details
            tempManager: null,
            canAddManager: true,
            filter: "",
            filteredMembers: [],
            membersUsersList: [],
            userChecked: "",
            allGroupParents: [],
            remainingParentsToShow: [],
            allUserParents: [],
            remainingUserParents: [],
            arrayUserParents: [],
            namePattern: false,
            groupStatus: true,
            showDisableConfirmation: false,
            savePayload: {},
            saveInitialData: {},
            groupsSystemCodes: ["ADMIN", "ALL_USERS", "EXT_USERS", "APPS_CREAT", "MAINTENANCE", "DATA_MNG"],
            hover: false,
            showByIndex: null,
            groupDuplicate: false,
            selectedValues: [],
            disabledBtn: true,
            processDefinitionsRoles: [],
            inheritedRolesPermissions: [],
            titleDialog: this.$t("admin.usersAndRoles.addRoleModal.titleNotif"),
            messageDialog: this.$t("admin.usersAndRoles.addRoleModal.messageNotif"),
            buttonsToHide: ["edit", "more", "copy", "download"],
            warningDlg: false
        };
    },
    validations: {
        editedRoleDetails: {
            name: {
                required
            }
        }
    },
    computed: {
        ...mapGetters("admin", [
            "userList",
            "getCurrentUsers",
            "getUsersRoleList",
            "getUsersforEdit",
            "getPermissionsRoleList",
            "getCurrentPermissions",
            "getCurrentGroupSelected",
            "getGroupsListApp",
            "getCurrentMembers",
            "appSettingsData",
            "getParentsGroupSelected",
            "roleList",
            "getPermissionsRolesGroupSelected"
        ]),
        ...mapGetters("apps", ["apps", "getCurrentAppUserPermissions", "currentApp"]),
        ...mapGetters("userProfile", ["userCookieInfo"]),
        hasSave() {
            return {
                label: this.$t("generic.save"),
                disabled: this.disabledBtn
            };
        },
        hasPrimary() {
            return {
                label: this.$t("generic.done"),
                disabled: this.disabledBtn
            };
        },
        returnModalTitle() {
            return this.actionType ? this.$t("admin.usersAndRoles.addGroupMembers.editTitleModal")
                : this.$t("admin.usersAndRoles.addGroupMembers.addTitleModal");
        },
        getAppIdGroup() {
            let appId = "";
            if (this.manageGroups) {
                appId = this.currentApp.id;
            } else if (this.editedRoleDetails && this.editedRoleDetails.type === "TPD") {
                appId = this.editedRoleDetails.applicationId;
            }
            return appId;
        },
        checkIfUseProcessDefId() {
            return !this.manageGroups && this.inEditRow && this.inEditRow.systemType === "APPLICATION";
        },
        filterMembers() {
            return this.allGroupMembers.filter(member => {
                let result = false;
                if (member.name) {
                    result = member.name.toLowerCase().includes(this.filter.toLowerCase());
                }
                if (!result && member.email) {
                    result = member.email.toLowerCase().includes(this.filter.toLowerCase());
                }
                return result;
            });
        },
        getFirstParents() {
            return this.allGroupParents.length > 2 ? this.allGroupParents.slice(0, 2) : this.allGroupParents;
        },
        save() {
            if (this.appSettings && !this.inEditRow) {
                return { label: this.$t("admin.usersAndRoles.addRoleModal.add") };
            } if (this.appSettings && this.inEditRow) {
                return { label: this.$t("admin.usersAndRoles.addRoleModal.update") };
            }
            return { label: this.$t("admin.usersAndRoles.addRoleModal.save"), color: "positive" };
        },
        checkAllGroupParents() {
            return this.allGroupParents && this.allGroupParents.length && this.groupStatus;
        },
        getGroupParentsIds() {
            let groupParentsId = [];
            if (this.allGroupParents && this.allGroupParents.length) {
                groupParentsId = this.allGroupParents.map(element => element.id);
            }
            return groupParentsId;
        },
        checkAddManager() {
            return !(this.groupsSystemCodes.includes(this.currentCodeGroup)) && this.groupStatus;
        },
        showPermissions() {
            return (this.currentTypeGroup === "TPD" || !this.groupsSystemCodes.includes(this.currentCodeGroup)) && this.groupStatus;
        },
        readonlyGroupName() {
            return !this.groupStatus || this.groupsSystemCodes.includes(this.currentCodeGroup) || this.editedRoleDetails.type === "EXTERNAL";
        },
        showPermissionsOnManageGroup() {
            let showPermissions = true;
            if (this.manageGroups) {
                if (this.checkIfReadonlyPermissions) {
                    showPermissions = !!(this.processDefinitionsRoles.length || this.inheritedRolesPermissions.length);
                }
            }

            return showPermissions;
        },
        checkIfReadonlyPermissions() {
            let isReadonly;
            if (this.manageGroups) {
                isReadonly = this.getCurrentAppUserPermissions.AS && this.getCurrentAppUserPermissions.AS.PE
                                && this.getCurrentAppUserPermissions.AS.PE.g === "r";
            }
            return !!isReadonly;
        },
        showGroupStatus() {
            return (this.inEditRow && this.currentTypeGroup === "TPD" && this.manageGroups)
                    || (this.inEditRow && this.currentTypeGroup !== "TPD" && !this.groupsSystemCodes.includes(this.currentCodeGroup));
        },
        showDisabledDetails() {
            return !!this.inEditRow && !this.groupStatus && this.editedRoleDetails.disabledDatetime;
        },
        groupNameError() {
            let err = false;
            if (this.editedRoleDetails && this.editedRoleDetails.name) {
                err = this.namePattern || this.groupDuplicate;
            } else if (this.dirty) {
                err = this.$v.$invalid;
            }
            return err;
        },
        groupNameErrorLabel() {
            let label = null;
            if (this.editedRoleDetails && this.editedRoleDetails.name) {
                if (this.namePattern) {
                    label = this.$t("admin.usersAndRoles.addRoleModal.roleSpaceError");
                } else if (this.groupDuplicate) {
                    label = this.$t("admin.usersAndRoles.addRoleModal.duplicateRoleError");
                }
            } else if (this.dirty && this.$v.$invalid) {
                label = this.$t("admin.usersAndRoles.addRoleModal.roleError");
            }
            return label;
        },
        getDisabledModifyBy() {
            return this.editedRoleDetails.modifiedBy ? `${this.editedRoleDetails.modifiedBy.firstName} ${this.editedRoleDetails.modifiedBy.lastName}` : "";
        },
        chooseManagerLabel() {
            let label = null;
            if (this.canAddManager) {
                if (this.hasManager) {
                    label = this.$t("admin.usersAndRoles.addRoleModal.changeManager");
                } else {
                    label = this.$t("admin.usersAndRoles.addRoleModal.selectManager");
                }
            } else {
                label = this.$t("admin.usersAndRoles.addRoleModal.noUsersManager");
            }
            return label;
        },
        badgeContent() {
            let content;
            if (!this.manageGroups && (this.inEditRow === null || this.editedRoleDetails.systemType === "PLATFORM")) {
                content = this.$t("admin.usersAndRoles.addRoleModal.platform");
            } else if (this.manageGroups || (this.editedRoleDetails && this.editedRoleDetails.systemType === "APPLICATION")) {
                content = this.$t("admin.usersAndRoles.addRoleModal.application");
            } else if (this.editedRoleDetails) {
                if (this.editedRoleDetails.systemType === "SYSTEM") {
                    content = this.$t("admin.usersAndRoles.addRoleModal.system");
                } else if (this.editedRoleDetails.systemType === "EXTERNAL") {
                    content = this.$t("admin.usersAndRoles.addRoleModal.external");
                }
            }
            return content;
        }

    },
    watch: {
        inEditRow: {
            handler(newValue) {
                if (newValue) {
                    this.currentCodeGroup = newValue.code;
                    this.currentTypeGroup = newValue.type;
                    this.editedRoleDetails = { ...newValue };
                    this.saveInitialData = { ...newValue };
                    this.groupStatus = this.editedRoleDetails.active;
                    if (this.editedRoleDetails && this.editedRoleDetails.members) {
                        this.allGroupMembers = this.editedRoleDetails.members;
                    }
                    if (newValue && !this.oldRoleName) {
                        this.oldRoleName = newValue.name;
                    }
                    if (this.manageGroups && newValue.id) {
                        // NO LONGER USED - NEED REFACTORING

                        // const alreadyExistElem = this.appSettingsData.find(element => {
                        //     const setConditionType = newValue.id ? element.id === newValue.id : element.name === newValue.name;
                        //     return setConditionType;
                        // });
                        // if (alreadyExistElem) {
                        //     this.$store.commit("admin/setCurrentGroupSelected", JSON.parse(JSON.stringify(alreadyExistElem)));
                        //     this.$store.commit("admin/setPermissionsRolesGroupSelected", []);
                        //     this.saveInitialData.members = [...alreadyExistElem.members];
                        //     this.saveInitialData.parents = [...alreadyExistElem.parents];
                        //     this.saveInitialData.permissions = [];
                        //     this.saveInitialData.processDefinitionsRoles = [...alreadyExistElem.processDefinitionsRoles];
                        //     this.processDefinitionsRoles = this.removeSpace([...alreadyExistElem.processDefinitionsRoles]);
                        // }

                        this.getGroupDetailsApps({ groupId: newValue.id }).then(
                            () => {
                                this.saveInitialData.members = [...this.getCurrentGroupSelected.members];
                                this.saveInitialData.parents = [...this.getCurrentGroupSelected.parents];
                                this.saveInitialData.permissions = [];
                                const directAppDetailAndRoles = this.getCurrentGroupSelected.directAppDetailAndRoles || [];
                                this.saveInitialData.processDefinitionsRoles = [...directAppDetailAndRoles];
                                this.processDefinitionsRoles = this.removeSpace([...directAppDetailAndRoles]);
                            }
                        );
                    } else {
                        this.getCurrentRoleEditedDetails({ roleId: newValue.id }).then(
                            () => {
                                this.saveInitialData.members = [...this.getCurrentMembers];
                                this.saveInitialData.parents = [...this.getParentsGroupSelected];
                            }
                        );
                    }
                } else {
                    this.$store.commit("admin/setCurrentGroupSelected", []);
                    this.$store.commit("admin/setUserRoleList");
                    this.$store.commit("admin/setPermissionsRoleList");
                }
            },
            immediate: true
        },
        getCurrentUsers: {
            handler(newValue) {
                this.currentAssignedUsers = this.getAllAssignedUsers(newValue);
            },
            immediate: true
        },
        getCurrentMembers: {
            handler(newValue) {
                this.hasManager = newValue.find(element => element.isManager);
                this.allGroupMembers = newValue;
            },
            immediate: true
        },
        getParentsGroupSelected: {
            handler(newValue) {
                if (newValue && newValue.length) {
                    this.remainingParentsToShow = newValue.slice(2, newValue.length);
                }
                this.allGroupParents = newValue;
            },
            immediate: true
        },
        getCurrentGroupSelected: {
            handler(newValue) {
                const dataMembers = newValue && newValue.members ? newValue.members : [];
                const dataParents = newValue && newValue.parents ? newValue.parents : [];
                this.inheritedRolesPermissions = newValue && newValue.inheritedProcessDetailsAndRoles ? newValue.inheritedProcessDetailsAndRoles : [];
                if (newValue.parents && newValue.parents.length) {
                    this.remainingParentsToShow = newValue.parents.slice(2, newValue.parents.length);
                }
                this.hasManager = dataMembers.find(element => element.isManager);
                this.allGroupMembers = dataMembers;
                this.allGroupParents = dataParents;
                if (this.editedRoleDetails && !this.editedRoleDetails.modifiedBy && newValue.modifiedBy) {
                    this.editedRoleDetails = { ...this.editedRoleDetails, modifiedBy: newValue.modifiedBy };
                }
            },
            immediate: true
        },
        getCurrentPermissions: {
            handler(newValue) {
                this.currentRolePermissions = this.getAllDetailsPermissions(newValue, this.apps);
                this.manualRolePermissions = this.getManualPermissions(newValue);
            },
            immediate: true
        },
        editedRoleDetails: {
            handler() {
                if ((this.editedRoleDetails.name !== this.oldRoleName) || this.editedRoleDetails.name !== null) {
                    this.dirty = true;
                } else {
                    this.dirty = false;
                }
            },
            deep: true
        },
        allGroupMembers: {
            handler(newValue) {
                if (newValue && newValue.length) {
                    this.allGroupMembersIds = newValue.map(element => element.id);
                    this.canAddManager = !!newValue.find(element => element.type === "USER");
                    if (this.hasManager) {
                        this.hasManager = newValue.find(element => element.id === this.hasManager.id);
                    }
                } else {
                    this.allGroupMembersIds = [];
                    this.canAddManager = false;
                    this.hasManager = null;
                }
            },
            immediate: true,
            deep: true
        },
        getPermissionsRolesGroupSelected: {
            handler(newValue) {
                if (newValue && this.inEditRow) {
                    if (!this.manageGroups) {
                        this.processDefinitionsRoles = this.removeSpace(newValue.directPermissions);
                    }
                    this.inheritedRolesPermissions = this.removeSpace(newValue.inheritedPermissions);
                }
            },
            immediate: true
        }
    },
    created() {
        this.$root.$on("changeValue", data => {
            if (!data) {
                this.disabledBtn = data;
            }
        });
    },
    methods: {
        ...mapActions("apps", ["actGetUserSystemPermissions"]),
        ...mapActions("admin", [
            "getUsersList",
            "getUsersForRole",
            "deleteUserFromRole",
            "saveEditRole",
            "createRole",
            "getPermissionsForRole",
            "getCurrentRoleEditedDetails",
            "getGroupDetailsApps",
            "getGroupParents",
            "saveAddEditGroup",
            "updateCreateGroupApp"
        ]),
        ...mapMutations("main", ["setInterfaceDirty"]),
        removeSpace(data) {
            const dataReturn = data || [];
            dataReturn.map(element => {
                const elem = JSON.parse(JSON.stringify(element));
                elem.roles = element.roles.map(role => {
                    if (role.code) {
                        role.code = role.code.trim();
                    }
                    return role;
                });
                return elem;
            });
            return dataReturn;
        },
        getName(member) {
            let name = "";
            if (member.name) {
                name = member.name;
            }
            if (member.type === "USER" && member.lastName) {
                name = `${name} ${member.lastName}`;
            }
            return name;
        },
        checkToggle() {
            this.disabledBtn = false;
            this.dirty = true;
        },
        setImage(user) {
            return user && user.avatar ? `/identity/tenants/users/image/${user.id}/s` : defaultAvatar;
        },
        mouseover(index) {
            this.showByIndex = index;
        },
        mouseleave() {
            this.showByIndex = null;
        },
        hoverManager() {
            this.hover = true;
        },
        hoverOutManager() {
            this.hover = false;
        },
        selectNewManager() {
            this.openedUserList = true;
            const managerUsersList = this.allGroupMembers.filter(element => element.type === "USER" && element.status === "ACTIVE");
            this.membersUsersList = managerUsersList.map(user => ({ ...user, type: user.systemType }));
        },
        setNewManager(data) {
            this.tempManager = data || null;
            if (this.tempManager) {
                this.dirty = true;
            }
        },
        userSelected(userId) {
            this.userChecked = userId;
            this.disabledBtn = false;
        },
        deleteManager() {
            this.hasManager = null;
            this.disabledBtn = false;
            this.dirty = true;
        },
        modalClosed() {
            this.currentSelectedPermission = {};
        },
        checkGroupName() {
            const validatePattern = new RegExp(GROUP_NAME_CHECK_REGEX);
            if (!validatePattern.test(this.editedRoleDetails.name)) {
                this.namePattern = true;
            } else {
                this.namePattern = false;
            }
            this.checkDuplicates();
            this.disabledBtn = false;
        },
        checkDuplicates() {
            if (this.editedRoleDetails.name) {
                let alreadyExistName = false;
                if (this.allGroupsTenantProcess && this.allGroupsTenantProcess.length) {
                    for (let i = 0; i < this.allGroupsTenantProcess.length; i++) {
                        if ((this.editedRoleDetails.name !== this.oldRoleName) && (this.editedRoleDetails.name === this.allGroupsTenantProcess[i].name)) {
                            alreadyExistName = true;
                            break;
                        }
                    }
                } else {
                    for (let i = 0; i < this.roleList.length; i++) {
                        if ((this.editedRoleDetails.name === this.roleList[i].name) && this.roleList[i].systemType === "PLATFORM") {
                            alreadyExistName = true;
                            break;
                        }
                    }
                }
                this.groupDuplicate = alreadyExistName;
            }
        },
        actionsDlg($event) {
            if ($event === "save") {
                this.$v.$touch();
                this.dirty = true;
                if (!(this.$v.$invalid || this.namePattern || this.groupDuplicate)) {
                    this.setObjectToSave();
                }
            } else if ($event === "close") {
                if (this.dirty) {
                    this.warningDlg = true;
                } else {
                    this.closeEditModal();
                }
            } else {
                this.closeEditModal();
            }
        },
        closeEditModal() {
            this.$store.commit("main/setInterfaceDirty", false);
            this.$emit("input");
            this.$emit("closeEditRole");
        },
        addedPermissionCheck() {
            this.dirty = true;
        },
        modalMembersDlg($event) {
            if ($event === "primary") {
                this.allSelectedMembers([...this.selectedValues]);
                this.disabledBtn = false;
            }
            this.showNewMembers = false;
        },
        actionsUserModal($event) {
            if ($event === "primary") {
                this.hasManager = this.tempManager;
                this.openedUserList = false;
                this.disabledBtn = false;
                this.dirty = true;
            } else if ($event === "close") {
                this.openedUserList = false;
                this.tempManager = this.hasManager;
            }
        },
        setObjectToSave() {
            let payload = {};
            if (this.groupStatus) {
                payload = this.setPayloadToSave(this.editedRoleDetails);
            } else {
                payload = this.setPayloadToSave(this.saveInitialData, true);
            }

            if (this.editedRoleDetails.id) {
                delete payload.code;
                delete payload.type;
            }
            if (this.groupStatus) {
                this.saveGroup(payload);
            } else if (!this.saveInitialData.active) {
                this.saved = true;
                this.opened = false;
                this.$emit("input");
            } else {
                this.savePayload = payload;
                this.showDisableConfirmation = true;
            }

            this.$store.commit("main/setInterfaceDirty", false);
        },

        setPayloadToSave(data, revert) {
            const nrOfUsersAndGroups = this.getNumberOfUsersAndGroups(revert ? data.members : null);
            return {
                active: this.groupStatus,
                code: uid(),
                id: data.id,
                name: data.name,
                type: "TD",
                editType: !!this.inEditRow,
                permissions: revert ? data.permissions : this.returnAssignedPermissions(),
                directAppDetailAndRoles: revert ? this.checkPermissionsRoles(data.processDefinitionsRoles) : this.setPermissionsRoles(),
                members: this.addManagerToSave(revert ? data.members : null),
                parents: data.parents || [],
                fromAdmin: this.manageGroups,
                applicationId: data.applicationId,
                nrOfGroups: nrOfUsersAndGroups.nrGroups,
                nrOfUsers: nrOfUsersAndGroups.nrUsers
            };
        },
        checkPermissionsRoles(data) {
            let permissions = null;
            let dataToReturn = null;
            if (data) {
                dataToReturn = data.map(element => {
                    const elem = JSON.parse(JSON.stringify(element));
                    elem.roles = element.roles;
                    return elem;
                });
            } else {
                permissions = this.processDefinitionsRoles.map(element => ({
                    targetId: element.id || element.targetId,
                    roles: element.permissions || element.roles,
                    permissionType: "PROCESS_DEFINITION"
                }));
            }
            return dataToReturn || permissions;
        },
        okAction() {
            this.saveGroup(this.savePayload);
            this.showDisableConfirmation = false;
            this.$emit("input");
        },
        saveGroup(payload) {
            const obj = payload;
            if (this.manageGroups) {
                delete obj.type;
                if (!payload.id && this.editedRoleDetails.code) {
                    obj.code = this.editedRoleDetails.code;
                }
                if (!payload.hasOwnProperty("type")) { obj.type = "TPD"; obj.systemType = "APPLICATION"; }
                this.$store.commit("admin/appSettingsData", payload);
                this.$store.commit("admin/updateRoleList", { data: payload });
                this.$store.commit("admin/setRoleList", { data: payload });
                this.updateCreateGroupApp(obj).then(
                    () => {
                        this.notificationSaveGroup();
                        this.actGetUserSystemPermissions();
                        eventBus.$emit("renderMenuFromAdmin");
                    }
                );
            } else if (this.editedRoleDetails.type === "TPD") {
                delete obj.type;
                this.$store.dispatch("admin/updateCreateGroupApp", payload).then(
                    () => {
                        if (!this.manageGroups) {
                            this.notificationSaveGroup();
                            this.actGetUserSystemPermissions();
                            eventBus.$emit("renderMenuFromAdmin");
                        }
                    }
                );
            } else {
                delete obj.applicationId;
                obj.active = this.groupStatus;
                this.saveAddEditGroup({ addNewGroup: !this.inEditRow, payload }).then(
                    () => {
                        this.notificationSaveGroup();
                        this.actGetUserSystemPermissions();
                        eventBus.$emit("renderMenuFromAdmin");
                    }
                );
            }
            this.$emit("input");
        },
        notificationSaveGroup() {
            let notifMessage;
            if (this.inEditRow) {
                if (this.groupStatus) {
                    notifMessage = this.$t("admin.usersAndRoles.editRoleModal.updateGroup");
                } else {
                    notifMessage = this.$t("admin.usersAndRoles.editRoleModal.disableGroup");
                }
            } else {
                notifMessage = this.$t("admin.usersAndRoles.addRoleModal.createGroup");
            }
            this.$toast.showNotify({
                type: "success",
                message: notifMessage
            });
            this.saved = true;
            this.opened = false;
        },
        getNumberOfUsersAndGroups(data) {
            let nrGroups = 0; let nrUsers = 0; const
                listMembers = data || this.allGroupMembers;

            listMembers.forEach(element => {
                if (element.type === "USER") {
                    nrUsers++;
                } else {
                    nrGroups++;
                }
            });
            return { nrGroups, nrUsers };
        },
        addManagerToSave(data) {
            const membersList = data || this.allGroupMembers;
            const memberListData = membersList.map(element => {
                const elem = JSON.parse(JSON.stringify(element));
                elem.isManager = !!this.hasManager && element.id === this.hasManager.id;
                return elem;
            });
            return memberListData;
        },

        addPermission() {
            this.addPermissionModal = true;
        },
        addNewMembers() {
            this.showNewMembers = true;
            this.dirty = true;
        },

        setPermissionsRoles() {
            const permissions = this.processDefinitionsRoles.map(element => ({
                targetId: element.id || element.targetId,
                roles: element.permissions || element.roles,
                permissionType: "PROCESS_DEFINITION"

            }));
            return permissions;
        },
        returnAssignedPermissions() {
            const dataToSend = [...this.currentRolePermissions]; let
                manualPerm = [];
            if (this.manualRolePermissions) {
                manualPerm = this.manualRolePermissions.split(",");
                manualPerm.forEach(perm => {
                    dataToSend.push({
                        permission: perm,
                        permissionType: "OTHER",
                        targetId: null
                    });
                });
            }

            return dataToSend;
        },

        deletePermission(index) {
            this.dirty = true;
            const dataPermissions = [...this.getCurrentPermissions];
            dataPermissions.splice(index, 1);
            this.$store.commit("admin/setPermissionsRoleList", { response: dataPermissions });
        },
        editPermission(permission) {
            this.currentSelectedPermission = permission;
            this.addPermissionModal = true;
            this.dirty = true;
        },
        getAllDetailsPermissions(data, app) {
            const dynamicPermissions = data.filter(elem => elem.permissionType === "PROCESS_DEFINITION");
            const dataToReturn = dynamicPermissions.map(element => {
                const elem = JSON.parse(JSON.stringify(element));
                const selectedApp = app.filter(apps => apps.id === element.targetId)[0];
                let permissionsType = null;
                permissionsType = element.permission ? element.permission.split(":") : null;
                elem.imageId = selectedApp && selectedApp.imageId ? selectedApp.imageId : "";
                elem.permissionLevels = permissionsType ? permissionsType[permissionsType.length - 1].split(",") : [];
                elem.name = selectedApp && selectedApp.name ? selectedApp.name : "";
                elem.publishStatus = selectedApp && selectedApp.publishStatus ? selectedApp.publishStatus : "";
                return elem;
            });
            return dataToReturn;
        },
        getManualPermissions(data) {
            const manualPermissions = data.filter(elem => elem.permissionType === "OTHER") || []; let
                allManual = "";
            manualPermissions.forEach(element => {
                allManual += allManual ? `,${element.permission}` : element.permission;
            });
            return allManual;
        },
        getAllAssignedUsers(users) {
            const dataToReturn = users.map(element => {
                const elem = JSON.parse(JSON.stringify(element));
                const currentUser = this.userList.filter(user => user.id === element.userId)[0];
                elem.email = currentUser && currentUser.email ? currentUser.email : "";
                return elem;
            });
            return dataToReturn;
        },
        getImagePath(id) {
            const path = `${ENGINE_REST_PATH}/app/files/${id}/IMAGE`;
            return path;
        },
        allSelectedMembers(data) {
            this.showNewMembers = false;
            if (data) {
                data.forEach(element => {
                    const alreadyExist = this.allGroupMembers.find(item => item.id === element.id);
                    if (!alreadyExist) {
                        this.allGroupMembers.push(element);
                    }
                });
            }
        },
        deleteMember(item) {
            const index = this.allGroupMembers.findIndex(el => el.id === item.id);
            if (index !== -1) {
                this.allGroupMembers.splice(index, 1);
            }
            this.disabledBtn = false;
            this.dirty = true;
        }

    }

};
